/**
 * Coffee Bean Clicker v2 - Mock Ad Provider
 * For web testing and development. Always succeeds after a short delay.
 */

import type { IAdProvider, AdReward, AdRewardType, AdStatus } from './AdProvider.js';

export class MockAdProvider implements IAdProvider {
  readonly name = 'MockAdProvider';
  private _status: AdStatus = 'idle';
  private currentReward: AdReward | null = null;

  get status(): AdStatus {
    return this._status;
  }

  set status(value: AdStatus) {
    this._status = value;
  }

  async initialize(): Promise<boolean> {
    console.log('[MockAdProvider] Initialized');
    this._status = 'idle';
    return true;
  }

  isRewardedAdReady(): boolean {
    return this._status === 'ready';
  }

  async loadRewardedAd(_rewardType?: AdRewardType): Promise<boolean> {
    if (this._status === 'loading') {
      console.log('[MockAdProvider] Already loading');
      return false;
    }

    this._status = 'loading';
    console.log('[MockAdProvider] Loading rewarded ad...');

    return new Promise((resolve) => {
      setTimeout(() => {
        this._status = 'ready';
        console.log('[MockAdProvider] Rewarded ad ready');
        resolve(true);
      }, 300);
    });
  }

  async showRewardedAd(_rewardType?: AdRewardType): Promise<AdReward | null> {
    if (this._status !== 'ready') {
      console.log('[MockAdProvider] Ad not ready, loading...');
      const loaded = await this.loadRewardedAd(_rewardType);
      if (!loaded) return null;
    }

    this._status = 'showing';
    console.log('[MockAdProvider] Showing rewarded ad (mock)...');

    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('[MockAdProvider] Ad completed, granting reward');
        const reward = this.currentReward;
        this._status = 'idle';
        this.currentReward = null;
        resolve(reward);
      }, 1000);
    });
  }

  setReward(reward: AdReward): void {
    this.currentReward = reward;
  }

  dispose(): void {
    this._status = 'idle';
    this.currentReward = null;
    console.log('[MockAdProvider] Disposed');
  }
}
